import { useQuery } from "@tanstack/react-query";
import { Api } from "@/api";
import { blogKeys } from "./keys";

/** Загружает одну опубликованную статью по идентификатору. */
export const useBlogArticle = (id: string) => {
	const query = useQuery({
		enabled: Boolean(id),
		queryFn: () => Api.Blog.getApiBlogById({ id }),
		queryKey: blogKeys.article(id),
	});
	return {
		data: query.data?.data ?? null,
		error: query.data?.error ?? null,
		isPending: query.isPending,
	};
};
